import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'irembogov-diff-summary-badge',
  templateUrl: './irembogov-diff-summary-badge.component.html',
  styleUrls: ['./irembogov-diff-summary-badge.component.scss'],
})
export class IrembogovDiffSummaryBadgeComponent {
  @Input() changeCount = 0;
  @Input() isNewService = false;
}
